import { isNil } from 'ramda'

import { useSubmitOtpVerificationMutation } from '@twisto/api-graphql'
import type { CastedSubmitHandler } from '@twisto/components/atoms/form'
import { Form, useForm } from '@twisto/components/atoms/form'
import { useResponseErrors } from '@twisto/form'

import { useFlow } from '../../flow/flow.context'

import { OtpVerificationFormContent } from './otp-verification-form-content'
import { OtpVerificationResendButton } from './otp-verification-resend-button'
import { OtpVerificationSmsStepHeadline } from './otp-verification-sms-step-headline'

const fieldNames = {
  code: 'code',
} as const

type FormValues = {
  [fieldNames.code]: string
}

export const OtpVerificationSmsStep = () => {
  const { sessionId, flow } = useFlow<'OtpVerificationSmsStep'>()

  const [submitCode, { data: submitOtpData }] =
    useSubmitOtpVerificationMutation()

  const step = flow.currentStep

  const formContext = useForm({
    defaultValues: {
      [fieldNames.code]: '',
    },
  })

  // handle field errors - such a invalid email
  useResponseErrors(submitOtpData?.submitOtpVerification, formContext)

  const handleSubmit: CastedSubmitHandler<FormValues> = ({
    code,
  }: FormValues) =>
    submitCode({
      variables: {
        auth: { sessionId },
        input: {
          code,
        },
      },
    })

  if (isNil(step)) {
    return null
  }

  return (
    <>
      <OtpVerificationSmsStepHeadline
        phoneNumber={step.phoneNumber.formattedPhoneNumber}
      />
      <Form {...formContext} onSubmit={handleSubmit}>
        <OtpVerificationFormContent />
      </Form>
      <OtpVerificationResendButton
        resendPossibleAt={step.resendPossibleAt}
        variant="sms"
      />
    </>
  )
}
